<template>
  <div class="dashboard">
    <BlockUI v-if="loading" :mensaje="'Cargando datos'"></BlockUI>
    <TituloComponent icono-titulo="fas fa-chart-line" texto-titulo="Ventas por artículos"></TituloComponent>
    <div class="card mb-3 col-12">
      <div class="card-body">
        <div class="row">
          <div class="widget-wrapper col-lg-6">
            <div class="widget-heading opacity-10">
              <float-label label="Artículo:" clase=" mb-md-0">
                <v-select v-model="articulo" :options="articulos"></v-select>
              </float-label>
            </div>
          </div>
          <div class="widget-wrapper col-lg-2">
            <div class="widget-heading opacity-10">
              <float-label label="Desde:" clase=" mb-md-0">
                <input type="date" id="desde" class="form-control" v-model="desde" />
              </float-label>
            </div>
          </div>
          <div class="widget-wrapper col-lg-2">
            <div class="widget-heading opacity-10">
              <float-label label="Hasta:" clase="mb-md-0">
                <input type="date" id="hasta" class="form-control" v-model="hasta" />
              </float-label>
            </div>
          </div>
          <div class="widget-wrapper col-lg-1">
            <div class="widget-heading opacity-10">
              <button type="button" @click="getEstadisticas" class="btn btn-block btn-info">Buscar</button>
            </div>
          </div>
          <div class="widget-wrapper col-lg-1" v-if="user.tipo == 'Administrador'">
            <div class="widget-heading opacity-10">
              <button type="button" @click="exportarExcel" class="btn btn-block btn-success" :disabled="loading">
                <i class="fas fa-file-excel"></i> Excel
              </button>
            </div>
          </div>
          <div class="col-12">
            <ul
              class="list-group list-group-flush my-3"
              v-if="recibido && ventas_articulo.length > 0"
            >
              <li
                class="list-group-item hoverable"
                v-for="(detalle, i) in ventas_articulo"
                :key="i"
                @click="ir(detalle)"
              >
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper row">
                    <div class="widget-content-left col-sm-9 col-12">
                      <h4 class="widget-heading text-primary opacity-10">{{detalle.descripcion}}</h4>
                      <div class="widget-subheading opacity-10 row">
                        <h5 class="col-sm-auto col-6">
                          Cantidad:
                          <b class="text-alternate">{{detalle.cantidad}}</b>
                        </h5>
                        <h5 class="col-sm-auto col-6" v-if="user.tipo == 'Administrador'">
                          Costo:
                          <b class="text-alternate">${{detalle.costo | numFormat('0,0.00')}}</b>
                        </h5>
                      </div>
                    </div>
                    <div class="widget-content-right col-sm-3 text-right">
                      <div class="widget-numbers text-danger">
                        <span class="count-up-wrapper">${{detalle.total | numFormat('0,0.00')}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div v-else>
              <div class="card mb-3 col-12">
                <div class="card-body">
                  <div class="row">
                    <div class="widget-wrapper col-lg-4">
                      <div class="widget-heading opacity-10">
                        <span class="text-danger">No hay datos disponibles</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import FloatLabel from "@/components/layouts/FloatLabel";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "VentasPorArticulo",
  components: {
    TituloComponent,
    FloatLabel,
    BlockUI,
  },
  computed: {
    ...mapGetters({
      user: "auth/user"
    }),
  },
  data() {
    return {
      ventas_articulo: [],
      recibido: false,
      loading: false,
      desde: null,
      hasta: null,
      articulos:[],
      articulo:{code:null, label: 'Seleccionar artículo'},
    };
  },
  mounted() {
    let date = new Date();
    let first_day = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    let last_day = new Date(date.getFullYear(), date.getMonth(), 0);
    this.desde = this.$options.filters.moment(first_day, "YYYY-MM-DD");
    this.hasta = this.$options.filters.moment(last_day, "YYYY-MM-DD");
    this.getArticulos();
    this.getEstadisticas();
  },
  methods: {
    getEstadisticas() {
      this.loading = true;
      let query = {
        desde: this.desde,
        hasta: this.hasta,
        articulo_id: this.articulo.code
      };
      axios
        .get("/estadisticas/ventas-articulo", { params: query })
        .then((res) => {
          if (res.data.success) {
            this.ventas_articulo = res.data.ventas_articulos;
            this.recibido = true;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getArticulos(){
        axios.get('/articulos')
        .then(res => {
            this.articulos.push(this.articulo)
            for(let articulo of res.data){
                // this.articulos.push(null);
                let item = {
                    code : articulo.id,
                    label: `${articulo.codigo}) ${articulo.descripcion}` 
                }
                this.articulos.push(item);
            }
        })
    },
    exportarExcel() {
      this.loading = true;
      let params = {
        desde: this.desde,
        hasta: this.hasta,
      };
      axios
        .get("/estadisticas/exportar-ventas-articulo", {
          params: params,
          responseType: "blob",
        })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `ventas_por_articulo_${this.desde}_${this.hasta}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((err) => {
          console.log(err);
          this.$swal("Error", "No se pudo descargar el archivo", "error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    ir(detalle){
      this.$router.push({name: 'VentasArticuloFecha',
      params:{'id': detalle.id,
        'descripcion': detalle.descripcion,
        'desde': this.desde,
        'hasta': this.hasta}})
    }
  },
};
</script>
